import type { StudioEditorHost } from '@genieartinc/core-ports';
import { StudioSnapshotSchema, StudioSaveSchema } from '@genieartinc/schemas/graph';
import { verifyStudioAsset } from './index';

export function createHttpStudioHost(baseUrl: string, canvasId: string, request: typeof fetch = fetch): StudioEditorHost {
  const root = `${baseUrl.replace(/\/$/, '')}/api/canvas/${encodeURIComponent(canvasId)}/studio`;
  async function call(path: string, init?: RequestInit) {
    const response = await request(root + path, { ...init, credentials: 'include' });
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body.error || `Project request failed (${response.status}).`);
    }
    return response;
  }
  return {
    async load() { return StudioSnapshotSchema.parse(await (await call('')).json()); },
    async save(change) {
      return StudioSnapshotSchema.parse(await (await call('', { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(StudioSaveSchema.parse(change)) })).json());
    },
    async putAsset(asset, bytes) {
      await verifyStudioAsset(asset, bytes);
      let binary = '';
      for (let i = 0; i < bytes.length; i += 8192) binary += String.fromCharCode(...bytes.subarray(i, i + 8192));
      await call('/assets', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ asset, base64: btoa(binary) }) });
    },
    async readAsset(asset) {
      const response = await call(`/assets/${encodeURIComponent(asset.id)}`);
      const bytes = new Uint8Array(await response.arrayBuffer());
      await verifyStudioAsset(asset, bytes);
      return bytes;
    },
  };
}
